import script from "./TimeOut.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeOut.vue?vue&type=script&setup=true&lang=js"

import "./TimeOut.vue?vue&type=style&index=0&id=37cd7ceb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37cd7ceb"]])

export default __exports__